import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sentences: [],
  loading: true,
  error: null,
  audioProgress: 0,
  isAudioPlaying: false,
  highlightedColors: [],
  sentencesLoadingIds: [],
  fetchedBooks: [],
  currentBatch: [],
};

const SentenceSlice = createSlice({
  name: "sentence",
  initialState,
  reducers: {
    fetchSentencesRequest: (state) => {
      state.currentBatch = [];
      state.loading = true;
    },
    fetchSentencesSuccess: (state, action) => {
      const newSentences = action.payload.sentences;

      // Assuming sentences have unique IDs or identifiable structure
      const existingSentenceIds = new Set(
        state.sentences.map((sentence) => sentence.id)
      );
      // Filter out already fetched sentences
      const uniqueSentences = newSentences.filter(
        (sentence) => !existingSentenceIds.has(sentence.id)
      );

      state.sentences = [...state.sentences, ...uniqueSentences];
      state.currentBatch = [...newSentences];
      state.loading = false;
    },
    fetchSentencesSuccessNoFetch: (state) => {
      state.loading = false;
    },
    fetchSentencesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    toggleAudioPlaying: (state) =>
      (state.isAudioPlaying = !state.isAudioPlaying),
    setAudioProgress: (state, action) => {
      state.audioProgress = action.payload;
    },
    setSentencesLoadingIds: (state, action) => {
      state.sentencesLoadingIds = action.payload;
    },
    toggleHighlight: (state, action) => {
      const language = action.payload;
      if (state.highlightedColors.includes(language)) {
        state.highlightedColors = state.highlightedColors.filter(
          (lang) => lang !== language
        );
      } else {
        state.highlightedColors.push(language);
      }
    },
  },
});

export const {
  fetchSentencesRequest,
  fetchSentencesFailure,
  fetchSentencesSuccess,
  fetchSentencesSuccessNoFetch,
  setSentencesLoadingIds,
  setAudioProgress,
  toggleAudioPlaying,
  toggleHighlight,
} = SentenceSlice.actions;

export default SentenceSlice.reducer;
